export default __webpack_public_path__ + "static/media/VIDEO_1.c39ae729.mp4";